import Topicview   from './components/Topicview'
import Listview    from './components/Listview'
import Detailview  from './components/Detailview'
import Login       from './components/Login'
import Subscribe   from './components/Subscribe'
import Webbook     from './components/Webbook'
import Messageview from './components/Messageview'
import Settings    from './components/Settings'
import Errorpage   from './components/Errorpage'

export default [
  {
    path: '/',
    //redirect: '/Base'
    name: process.env.VUE_APP_STARTPAGE == 'Topicview' ? 'BaseTopicview' : 'BaseListview',
    component: process.env.VUE_APP_STARTPAGE == 'Topicview' ?  Topicview : Listview
  },
  {
    path: '/top',
    name: 'Topicview',
    component: Topicview
  },
  {
    path: '/top/:topid/filter',
    name: 'Subtopicview',
    component: Topicview
  },
  {
    path: '/ms-testmode',
    component: Topicview,
  },
  {
    // Route takes the route parameter "topic".
    // The parameter value can be accessed with $route.params.id in the component.
    path: '/top/:topid/',
    name: 'Listview',
    component: Listview
  },
  {
    path: '/top/:topid/jump/:jumpid',
    name: 'Listview',
    component: Listview
  },
  {
    path: '/top/:topid/sub/:subid/',
    name: 'Sublistview',
    component: Listview
  },
  {
    path: '/top/:topid/sub/:subid/jump/:jumpid',
    name: 'Sublistview',
    component: Listview
  },
  {
    path: '/top/:topid/post/:postid',
    name: 'Detailview',
    component: Detailview
  },
  {
    path: '/top/:topid/post/:postid/fw/',
    name: 'ForwardDetailview',
    component: Detailview
  },
  {
    path: '/top/:topid/sub/:subid/post/:postid',
    name: 'Subdetailview',
    component: Detailview
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    // 06.11.2019: ROUTE IM AUGENBLICK NICHT MEHR IN BENUTZUNG
    path: '/subscribe',
    name: 'Subscribe',
    component: Subscribe
  },
  {
    path: '/node/:node',
    name: 'Webbook',
    component: Webbook,
    props: true
  },
  {
    path: '/messages/',
    name: 'Messageview',
    component: Messageview
  },
  {
    path: '/settings',
    name: 'Settings', 
    component: Settings,
    props: true
  },
  {
    path: '/error',
    name: 'Errorpage',
    component: Errorpage,
    props: true
  },      
];